// Which page the app lands on at "/" — resolved from the user's homePage preference
// (set in Preferences), the plan, and the activity opt-out. Shared by the root redirect
// in App.jsx and the Preferences page so the option list lives in one place.

// Selectable landing pages. Keep in sync with the main nav `links` in App.jsx;
// "activity" is only reachable when the tenant has collaboration and the user hasn't
// hidden it.
export const HOME_PAGE_OPTIONS = [
  "activity", "candidates", "tasks", "projects", "clients", "search", "documents",
];

// Resolve the effective landing path. "auto" (and anything unreachable) falls back to the
// plan default: the team activity feed when shown, else contacts. Never returns /activity
// when activity isn't shown (no collaboration, or the user opted out).
export function resolveHomePath(homePage, showActivity) {
  const planDefault = showActivity ? "/activity" : "/candidates";
  if (!homePage || homePage === "auto" || !HOME_PAGE_OPTIONS.includes(homePage)) {
    return planDefault;
  }
  if (homePage === "activity" && !showActivity) return "/candidates";
  return `/${homePage}`;
}
